
import { DISABLE_EXCLUDED_PAYER_URL, EXCLUDED_PAYER_CREATE_URL, EXCLUDED_PAYER_DETAIL_URL, EXCLUDED_PAYER_LIST_URL } from "../../api";
import axiosInstance from "../../axiosInstance";



export const getExcludedpayerList = (page, limit, search={}) => onResponse => {
    try {
        const {clients,facility,partner,is_active} = search
        axiosInstance.get(EXCLUDED_PAYER_LIST_URL, {
            params: {
                page: page,
                limit: limit,
                client: Array.isArray(clients)? clients?.join(','):"",
                facility: Array.isArray(facility)? facility?.join(','):"",
                partner: Array.isArray(partner)? partner?.join(','):"",
                is_active:is_active
            }
        })

            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

        }

};




export const createOrUpdateExcluded = (props) => onResponse => {
    try {
        axiosInstance.post(EXCLUDED_PAYER_CREATE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSingleExcludedDetail = (id) => onResponse => {
    try {
        axiosInstance.post(EXCLUDED_PAYER_DETAIL_URL,{excluded_payer
:id})
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const enableOrDisableExcluded = (id) => onResponse => {
    try {
        axiosInstance.post(DISABLE_EXCLUDED_PAYER_URL, {
            excluded_payer:id

        })
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                onResponse(err);
            });
    } catch (error) {

    }
} 